module.exports = __webpack_public_path__ + "img/lanmu-06.989c6e63.jpg";